module.exports = __webpack_public_path__ + "media/font/summernote-f5bf9564.woff2";